import React, { Component } from "react";

import { trackPromise } from "react-promise-tracker";
import Popup from "react-popup";
import {FontAwesomeIcon}  from "@fortawesome/react-fontawesome";
import {faArrowLeft, faArrowRight,faRotate} from "@fortawesome/free-solid-svg-icons";
import $ from "jquery";
import MensajeUsuario from "../../../generico/MensajeUsuario";
import TransferInterbancaService from "../../../../services/transferencias/TransferInterbancaService";
import ConfigService from "../../../../services/configuracion/ConfigService";
import SoftTokenService from "../../../../services/softToken/SoftTokenService";
export default class TransferCuentasTerceros extends Component {
  constructor(props) {
    super(props);
    this.state = this.getInitialState();
    this.startCountdown = this.startCountdown.bind(this);
    this.setState({mostrarSegundos:40});
  }
  muestraEntrust = false;
  getInitialState = () => ({
    
    motivo: "",
    nroOperacion: 0,
    disableSgte: true,
    otrosDesc: "",
    mostrarSegundos: 40,
    mostrarTemp: true
  });
  countdown = 10;
  invervalId = 0;
  onChangePassword(e) {
    this.setState({
      password: e.target.value,
    });
  }
  
  

  resetState = () => {
    this.setState(this.getInitialState());
    
  };
  
  componentDidMount() {
    this.startCountdown();
  }
  startCountdown() {
    this.countdown = 40;
    this.setState({
      mostrarSegundos: 40
    });
    this.invervalId = setInterval(() => {
      this.countdown--;
      this.setState({
        mostrarSegundos: this.countdown
      });

      if (this.countdown === 0) {
        this.stopCountdown();
        this.setState({
          mostrarTemp: false
        });


      }
    }, 1000)
  }
  stopCountdown() {
    clearInterval(this.invervalId);
  }
  notifiPopup = (titulo, mensaje) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Aceptar",
            className: "success",
            action: function () {
              Popup.close();
            },
          },
        ],
      },
    });

  
  
  
  obtenerOTP = () => {
    this.setState({
        mostrarTemp: true
      });
    trackPromise(
     TransferInterbancaService.generarOTP()
       .then(( response ) => {
        this.startCountdown();
        return response.data.datos
        
       })
       .catch(error => {
         console.log(error);
       }),
   )
   this.startCountdown();
 }

  limpiarInp = () => {
    document.getElementById("idFormPaso3").reset();
  }
 

  enableNext(codigo, motivo, otrosDesc) {
    if (codigo !== "") {
      this.setState({disableSgte : false});
        // this.state.disableSgte = false;
      

    } else {
      this.setState({disableSgte:true});
      // this.state.disableSgte = true;
    }
  }

  ocultarMenuDinamico (tipoValidacion){
    this.muestraEntrust = this.props.muestraPantallaEntrust;
    if( tipoValidacion === 'entrust' ){
      return this.muestraEntrust ? 
      null : {display:"none"}
    }else if(tipoValidacion === 'otpSms'){
      return ConfigService.ocultarSegunNombre('otpSms') === null && !this.muestraEntrust ?
      null : {display : "none"};
    }
  }

  render() {
    return (
      <div>
        <form id="idFormPaso3"  onSubmit={(e) => e.preventDefault()}>
          <div className="row">
            <div className="steps clearfix">
              <ul role="tablist">
                <li role="tab" className="disabled">
                  <span>
                    <div className="title">
                      <span className="title_text current">
                        Selección de Cuentas
                      </span>
                    </div>
                  </span>
                </li>
               
                <li role="tab" className="current">
                  <span>
                    <div className="title">
                      <span className="title_text">Código de Verificación</span>
                    </div>
                  </span>
                </li>
                <li role="tab" className="disabled">
                  <span>
                    <div className="title">
                      <span className="title_text">Datos de Verificación</span>
                    </div>
                  </span>
                </li>
                
                <li role="tab" className="disabled last">
                  <span>
                    <div className="title">
                      <span className="title_text">Confirmación</span>
                    </div>
                  </span>
                </li>
              </ul>
            </div>
          </div>

          <div className="row" style={this.ocultarMenuDinamico('entrust')}>
              <div className="col-lg-6 col-md-6">
                <div className="d-flex align-items-center justify-content-center">
                  <img src="./dist/img/tokenPasos.png" width={300} alt="Pasos" className="img-fluid"/>
                </div>
              </div>
              <div className="col-lg-6" style={{marginBottom: '3rem',paddingTop:'1rem'}} >
                <MensajeUsuario   
                  tipo="INFO"
                  titulo="Importante!"
                  // mensaje="-Introduzca el código de verificación que fue enviado a su teléfono por SMS.
                  // Obs: Se envia un código de verificación distinto por cada transferencia."
                  mensaje="-Introduzca el código de seguridad(TOKEN) que está en la aplicación de la cooperativa."
                />
                <div className="form-group" style={{paddingTop:'3rem'}}>
                  <label className="input-label-bold">Código de Verificación *</label>
                  
                  <input
                    value={this.state.codigo}
                    type="password"
                    maxLength="6"
                    name="codigo"
                    className="form-control input-box"
                    onChange={(evt) => {
                      this.setState({ codigootp: evt.target.value });
                      this.enableNext(this.state.codigootp);
                    }}
                  />  
                </div>
              </div>
              
              
          </div>

          <div className="row" style={this.ocultarMenuDinamico('otpSms')}>
              <div className="col-12" style={{marginBottom: '3rem'}}>
                <MensajeUsuario   
                  tipo="INFO"
                  titulo="Importante!"
                  // mensaje="-Introduzca el código de verificación que fue enviado a su teléfono por SMS.
                  // Obs: Se envia un código de verificación distinto por cada transferencia."
                  mensaje="-Introduzca el OTP que fue enviado a su teléfono por SMS.
                  Obs: Se envia un código de verificación distinto por cada transferencia."
                />
              </div>
                
              <div className="col-lg-6 col-md-10">
                <div className="form-group">
                  <label className="input-label-bold">Código de Verificación *</label>
                  <input
                    value={this.state.codigo}
                    type="password"
                    maxLength="6"
                    name="codigo"
                    className="form-control input-box"
                    onChange={(evt) => {
                      this.setState({ codigootp: evt.target.value });
                      this.enableNext(this.state.codigootp);
                    }}
                  
                  />  
                </div>
              </div>
              <div className="col-lg-2 col-md-2" style={{display:'grid',alignItems:'center',textAlign:'center'}}>
                {!this.state.mostrarTemp &&
                      <button className="btn btn-reenvio"
                        onClick={() => {
                          this.obtenerOTP();
                        }}
                      >
                        <FontAwesomeIcon icon={faRotate} />  Reenviar código
                      </button>
                }
                {this.state.mostrarTemp &&
                  <button className="btn btn-reenvio-des"

                  >
                    <FontAwesomeIcon icon={faRotate} />  Reenviar código
                  </button>
                }                  
                  
                 
              </div>
              <div className="col-lg-12 col-md-10 p-0">
                {this.state.mostrarTemp &&
                  <div class="temp text-reenv">Podrá reenviar el código de verificación en {this.state.mostrarSegundos}   segundos</div>
                }
              </div>
          </div>

          
          <hr />

          <div className="row">
            <div className="col-lg-8 col-md-6">
                <label
                  className="input-label-bold-obligatorio">
                  (*) Campos Obligatorios
                  <br />
                </label>
            </div>
            <div className="col-lg-2 col-md-3">
                <button
                  className="btn btn-cu-quintary btn-consulta"
                  onClick={() => {
                    this.props.previousStep();
                  }}
                >
                <FontAwesomeIcon icon={faArrowLeft} />  Volver
                </button>

            </div>
            <div className="col-lg-2 col-md-3">
            <button
                  id="btn-continue"
                  className="btn btn-cu-primary"
                  disabled={this.state.disableSgte}
                  onClick={() => {
                    $('#btn-continue').attr('disabled', 'true');
                    if (this.props.currentStep === 2) {
                      if( this.muestraEntrust ){
                        SoftTokenService.validarOtpToken(this.state.codigootp)
                        .then( (response)=>{
                          // console.log(response.data);
                          if( response.data.codigo === 0 ){
                            this.props.returnDataOTP(this.state.codigootp);
                            this.props.nextStep();
                          }else {
                            Popup.queue(this.notifiPopup("Error", response.data.mensaje));
                            $('#btn-continue').attr('disabled', 'false');
                            this.limpiarInp();
                            this.setState({disableSgte:true})
                            // this.state.disableSgte = true;
                          }
                        })
                        .catch( err => {
                          console.log(err);
                        });
                      }else{
                        TransferInterbancaService.validarOTP(this.state.codigootp)
                        .then((response ) => {
                          if(response.data.codigoRetorno === "0"){
                            this.props.returnDataOTP(this.state.codigootp);
                            this.props.nextStep();
                          }
                          else {
                            Popup.queue(this.notifiPopup("Error", response.data.mensajeRetorno));
                            this.setState({disableSgte:true});
                            // this.state.disableSgte = true;
                            this.limpiarInp();
                          }
                        })
                        .catch(error => {
                          console.log(error);
                        })
                      } 
                        
                    }
                  }}
                >
                  Continuar <FontAwesomeIcon icon={faArrowRight} />
                </button>
            </div>
          </div>

        </form>
      </div>
    );
  }
}